import { Helmet } from 'react-helmet'

export const HREFLANG = {
  'home': [
    <link
      key="home-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/"
    />,
    <link
      key="home-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/"
    />,
    <link
      key="home-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/"
    />,
    <link
      key="home-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/"
    />,
    <link
      key="home-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/"
    />,
    <link
      key="home-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/"
    />,
    <link
      key="home-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/"
    />,
    <link
      key="home-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/"
    />,
    <link
      key="home-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/"
    />,
    <link
      key="home-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/"
    />,
    <link
      key="home-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/"
    />,
    <link
      key="home-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/"
    />,
    <link
      key="home-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/"
    />,
    <link
      key="home-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/"
    />,
    <link
      key="home-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://www.fun88.com/"
    />,
  ],
  'sports': [
    <link
      key="sports-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/กีฬา/"
    />,
    <link
      key="sports-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/the-thao/"
    />,
    <link
      key="sports-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/sports/"
    />,
    <link
      key="sports-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/sports/"
    />,
    <link
      key="sports-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/sports/"
    />,
    <link
      key="sports-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/betting-exchange"
    />,
    <link
      key="sports-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/sports"
    />,
    <link
      key="sports-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/sports/"
    />,
    <link
      key="sports-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/sports/"
    />,
    <link
      key="sports-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/sports/"
    />,
    <link
      key="sports-x-default"
      rel="alternate"
      href="https://global.fun88.com/sports/"
      hrefLang="x-default"
    />,
  ],
  'casino': [
    <link
      key="casino-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/คาสิโน/"
    />,
    <link
      key="casino-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/live-casino/"
    />,
    <link
      key="casino-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/live-casino/"
    />,
    <link
      key="casino-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/casino/"
    />,
    <link
      key="casino-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/casino/"
    />,
    <link
      key="casino-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/live-casino"
    />,
    <link
      key="casino-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/casino/inicio"
    />,
    <link
      key="casino-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/casino/inicio"
    />,
    <link
      key="casino-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/casino/inicio"
    />,
    <link
      key="casino-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/casino/inicio"
    />,
    <link
      key="casino-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/casino/inicio"
    />,
    <link
      key="casino-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/live-casino/"
    />,
    <link
      key="casino-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/live-casino/"
    />,
    <link
      key="casino-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/live-casino/"
    />,
    <link
      key="casino-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/live-casino/"
    />,
  ],
  'promotions': [
    <link
      key="promotions-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/โปรโมชั่น/"
    />,
    <link
      key="promotions-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/promotions/"
    />,
    <link
      key="promotions-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/promotions/"
    />,
    <link
      key="promotions-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/promotions/"
    />,
    <link
      key="promotions-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/promotions/"
    />,
    <link
      key="promotions-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/promotions"
    />,
    <link
      key="promotions-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/promotions"
    />,
    <link
      key="promotions-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/promotions"
    />,
    <link
      key="promotions-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/promotions"
    />,
    <link
      key="promotions-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/promotions"
    />,
    <link
      key="promotions-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/promotions"
    />,
    <link
      key="promotions-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/promotions/"
    />,
    <link
      key="promotions-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/promotions/"
    />,
    <link
      key="promotions-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/promotions/"
    />,
    <link
      key="promotions-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/promotions/"
    />,
  ],
  'blogs': [
    <link
      key="blogs-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/blog/"
    />,
    <link
      key="blogs-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/blog/"
    />,
    <link
      key="blogs-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/blog/"
    />,
    <link
      key="blogs-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/blogs"
    />,
    <link
      key="blogs-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/blogs"
    />,
    <link
      key="blogs-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/blogs"
    />,
    <link
      key="blogs-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/blogs"
    />,
    <link
      key="blogs-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/blogs"
    />,
  ],
  'register': [
    <link
      key="register-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/register/"
    />,
    <link
      key="register-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/register/"
    />,
    <link
      key="register-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/register/"
    />,
    <link
      key="register-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/register/"
    />,
    <link
      key="register-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/register/"
    />,
    <link
      key="register-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/signup"
    />,
    <link
      key="register-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/register"
    />,
    <link
      key="register-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/register"
    />,
    <link
      key="register-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/register"
    />,
    <link
      key="register-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/register"
    />,
    <link
      key="register-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/register"
    />,
    <link
      key="register-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/register/"
    />,
    <link
      key="register-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/register/"
    />,
    <link
      key="register-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/register/"
    />,
    <link
      key="register-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/register/"
    />,
  ],
  'login': [
    <link
      key="login-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/login/"
    />,
    <link
      key="login-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/login/"
    />,
    <link
      key="login-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/login/"
    />,
    <link
      key="login-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/login/"
    />,
    <link
      key="login-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/login/"
    />,
    <link
      key="login-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/login"
    />,
    <link
      key="login-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/login/"
    />,
    <link
      key="login-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/login/"
    />,
    <link
      key="login-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/login/"
    />,
    <link
      key="login-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/login/"
    />,
  ],
  'slots': [
    <link
      key="slots-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/สล็อต/"
    />,
    <link
      key="slots-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/slots/"
    />,
    <link
      key="slots-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/slots/"
    />,
    <link
      key="slots-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/slots/"
    />,
    <link
      key="slots-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/slots/"
    />,
    <link
      key="slots-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/slots"
    />,
    <link
      key="slots-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/casino/slots"
    />,
    <link
      key="slots-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/casino/slots"
    />,
    <link
      key="slots-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/casino/slots"
    />,
    <link
      key="slots-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/casino/slots"
    />,
    <link
      key="slots-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/casino/slots"
    />,
    <link
      key="slots-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/slots/"
    />,
    <link
      key="slots-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/slots/"
    />,
    <link
      key="slots-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/slots/"
    />,
    <link
      key="slots-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/slots/"
    />,
  ],
  'crash': [
    <link
      key="crash-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/เกมความเร็ว/crash-games/"
    />,
    <link
      key="crash-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/arcade-games/crash-games/"
    />,
    <link
      key="crash-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/arcade-games/crash/"
    />,
    <link
      key="crash-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/arcade-games/crash/"
    />,
    <link
      key="crash-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/casino/crash"
    />,
    <link
      key="crash-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/casino/crash"
    />,
    <link
      key="crash-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/casino/crash"
    />,
    <link
      key="crash-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/casino/crash"
    />,
    <link
      key="crash-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/casino/crash"
    />,
  ],
  'app': [
    <link
      key="app-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/ดาวน์โหลด-fun88/"
    />,
    <link
      key="app-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/download-app/"
    />,
    <link
      key="app-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/download-app/"
    />,
    <link
      key="app-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/download-app/"
    />,
    <link
      key="app-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/download-app/"
    />,
    <link
      key="app-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/app-download"
    />,
    <link
      key="app-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/download-app/"
    />,
    <link
      key="app-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/download-app/"
    />,
    <link
      key="app-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/download-app/"
    />,
    <link
      key="app-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/download-app/"
    />,
  ],
  'sponsorship': [
    <link
      key="sponsorship-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/sponsorship/"
    />,
    <link
      key="sponsorship-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/sponsorship/"
    />,
    <link
      key="sponsorship-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/sponsorship/"
    />,
    <link
      key="sponsorship-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/sponsorship/"
    />,
    <link
      key="sponsorship-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/sponsorship/"
    />,
    <link
      key="sponsorship-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/sponsors"
    />,
    <link
      key="sponsorship-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/sponsors"
    />,
    <link
      key="sponsorship-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/sponsors"
    />,
    <link
      key="sponsorship-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/sponsors"
    />,
    <link
      key="sponsorship-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/sponsors"
    />,
    <link
      key="sponsorship-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/sponsors"
    />,
    <link
      key="sponsorship-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/sponsorship/"
    />,
    <link
      key="sponsorship-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/sponsorship/"
    />,
    <link
      key="sponsorship-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/sponsorship/"
    />,
    <link
      key="sponsorship-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/sponsorship/"
    />,
  ],
  'faq': [
    <link
      key="faq-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://csp.fun88thh.com/?language=th"
    />,
    <link
      key="faq-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://csp.fun88vnu.com/?language=vn"
    />,
    <link
      key="faq-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://csp.fun88zh.com/?language=cn"
    />,
    <link
      key="faq-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/customer-service/"
    />,
    <link
      key="faq-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/customer-service/"
    />,
    <link
      key="faq-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/about/faq"
    />,
    <link
      key="faq-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/help/faq"
    />,
    <link
      key="faq-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/help/faq"
    />,
    <link
      key="faq-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/help/faq"
    />,
    <link
      key="faq-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/help/faq"
    />,
    <link
      key="faq-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/help/faq"
    />,
    <link
      key="faq-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/faq/"
    />,
    <link
      key="faq-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/faq/"
    />,
    <link
      key="faq-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/faq/"
    />,
    <link
      key="faq-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/faq/"
    />,
  ],
  'esports': [
    <link
      key="esports-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/อีสปอร์ต/"
    />,
    <link
      key="esports-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/esports/"
    />,
    <link
      key="esports-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/esports/"
    />,
    <link
      key="esports-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/esports/"
    />,
    <link
      key="esports-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/esports/"
    />,
    <link
      key="esports-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/esports/"
    />,
    <link
      key="esports-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/esports/"
    />,
    <link
      key="esports-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/esports/"
    />,
    <link
      key="esports-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/esports/"
    />,
  ],
  'arcade': [
    <link
      key="arcade-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/เกมความเร็ว/"
    />,
    <link
      key="arcade-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/arcade-games/"
    />,
    <link
      key="arcade-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/arcade-games/"
    />,
    <link
      key="arcade-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/arcade-games/"
    />,
    <link
      key="arcade-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/arcade-games/"
    />,
    <link
      key="arcade-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/instant-games"
    />,
    <link
      key="arcade-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/casino/casual"
    />,
    <link
      key="arcade-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/casino/casual"
    />,
    <link
      key="arcade-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/casino/casual"
    />,
    <link
      key="arcade-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/casino/casual"
    />,
    <link
      key="arcade-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/casino/casual"
    />,
    <link
      key="arcade-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/arcade-games/"
    />,
    <link
      key="arcade-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/arcade-games/"
    />,
    <link
      key="arcade-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/arcade-games/"
    />,
    <link
      key="arcade-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/arcade-games/"
    />,
  ],
  'fishing': [
    <link
      key="fishing-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/fishing/"
    />,
    <link
      key="fishing-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/ban-ca/"
    />,
    <link
      key="fishing-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/fishing/"
    />,
    <link
      key="fishing-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/fishing/"
    />,
    <link
      key="fishing-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/fishing/"
    />,
    <link
      key="fishing-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/fishing/"
    />,
    <link
      key="fishing-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/fishing/"
    />,
    <link
      key="fishing-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/fishing/"
    />,
    <link
      key="fishing-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/fishing/"
    />,
  ],
  'lottery': [
    <link
      key="lottery-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.fun88thh.com/th/หวย/"
    />,
    <link
      key="lottery-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.fun88vnu.com/vn/xo-so/"
    />,
    <link
      key="lottery-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.fun88zh.com/cn/lottery/"
    />,
    <link
      key="lottery-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/lottery/"
    />,
    <link
      key="lottery-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/lottery/"
    />,
    <link
      key="lottery-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/casino/bingo"
    />,
    <link
      key="lottery-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/casino/bingo"
    />,
    <link
      key="lottery-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/casino/bingo"
    />,
    <link
      key="lottery-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/casino/bingo"
    />,
    <link
      key="lottery-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/casino/bingo"
    />,
    <link
      key="lottery-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/lottery/"
    />,
    <link
      key="lottery-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/lottery/"
    />,
    <link
      key="lottery-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/lottery/"
    />,
    <link
      key="lottery-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/lottery/"
    />,
  ],
  'sobre-nosotros': [
    <link
      key="sobre-nosotros-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://csp.fun88thh.com/?language=th&articleNumber=000009379"
    />,
    <link
      key="sobre-nosotros-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://csp.fun88vnu.com/?language=vn&articleNumber=000006822"
    />,
    <link
      key="sobre-nosotros-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://csp.fun88zh.com/?language=cn&articleNumber=000009121"
    />,
    <link
      key="sobre-nosotros-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/customer-service/#about"
    />,
    <link
      key="sobre-nosotros-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/customer-service/#about"
    />,
    <link
      key="sobre-nosotros-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/about/about-us"
    />,
    <link
      key="sobre-nosotros-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/help/we"
    />,
    <link
      key="sobre-nosotros-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/help/we"
    />,
    <link
      key="sobre-nosotros-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/help/we"
    />,
    <link
      key="sobre-nosotros-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/help/we"
    />,
    <link
      key="sobre-nosotros-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/help/we"
    />,
    <link
      key="sobre-nosotros-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/about-us/"
    />,
    <link
      key="sobre-nosotros-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/about-us/"
    />,
    <link
      key="sobre-nosotros-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/about-us/"
    />,
    <link
      key="sobre-nosotros-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/about-us/"
    />,
  ],
  'terminos-y-condiciones': [
    <link
      key="terminos-y-condiciones-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://csp.fun88thh.com/?language=th&articleNumber=000006816"
    />,
    <link
      key="terminos-y-condiciones-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://csp.fun88vnu.com/?language=vn&articleNumber=000009352"
    />,
    <link
      key="terminos-y-condiciones-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://csp.fun88zh.com/?language=cn&articleNumber=000006905"
    />,
    <link
      key="terminos-y-condiciones-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/customer-service/#terms"
    />,
    <link
      key="terminos-y-condiciones-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/customer-service/#terms"
    />,
    <link
      key="terminos-y-condiciones-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/about/terms-conditions"
    />,
    <link
      key="terminos-y-condiciones-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/help/terminos-y-condiciones"
    />,
    <link
      key="terminos-y-condiciones-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/help/terminos-y-condiciones"
    />,
    <link
      key="terminos-y-condiciones-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/help/terminos-y-condiciones"
    />,
    <link
      key="terminos-y-condiciones-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/help/terminos-y-condiciones"
    />,
    <link
      key="terminos-y-condiciones-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/help/terminos-y-condiciones"
    />,
    <link
      key="terminos-y-condiciones-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/terms-conditions/"
    />,
    <link
      key="terminos-y-condiciones-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/terms-conditions/"
    />,
    <link
      key="terminos-y-condiciones-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/terms-conditions/"
    />,
    <link
      key="terminos-y-condiciones-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/terms-conditions/"
    />,
  ],
  'aviso-de-privacidad-y-cookies-del-sitio': [
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://csp.fun88thh.com/?language=th&articleNumber=000010234"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://csp.fun88vnu.com/?language=vn&articleNumber=000010235"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://csp.fun88zh.com/?language=cn&articleNumber=000010233"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/customer-service/#privacy"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/customer-service/#privacy"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/about/privacy-policy"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/help/privacy-notice-and-site-cookies"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/help/privacy-notice-and-site-cookies"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/help/privacy-notice-and-site-cookies"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/help/privacy-notice-and-site-cookies"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/help/privacy-notice-and-site-cookies"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/privacy-policy/"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/privacy-policy/"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/privacy-policy/"
    />,
    <link
      key="aviso-de-privacidad-y-cookies-del-sitio-x-default"
      rel="alternate"
      hrefLang="x-default"
      href="https://global.fun88.com/privacy-policy/"
    />,
  ],
  'juego-responsable': [
    <link
      key="juego-responsable-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://csp.fun88thh.com/?language=th&articleNumber=000010223"
    />,
    <link
      key="juego-responsable-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://csp.fun88vnu.com/?language=vn&articleNumber=000009797"
    />,
    <link
      key="juego-responsable-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://csp.fun88zh.com/?language=cn&articleNumber=000010221"
    />,
    <link
      key="juego-responsable-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/customer-service/#responsible"
    />,
    <link
      key="juego-responsable-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/customer-service/#responsible"
    />,
    <link
      key="juego-responsable-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/about/responsible-gambling"
    />,
    <link
      key="juego-responsable-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/help/juego-responsable"
    />,
    <link
      key="juego-responsable-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/help/juego-responsable"
    />,
    <link
      key="juego-responsable-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/help/juego-responsable"
    />,
    <link
      key="juego-responsable-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/help/juego-responsable"
    />,
    <link
      key="juego-responsable-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/help/juego-responsable"
    />,
    <link
      key="juego-responsable-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/responsible-gaming/"
    />,
    <link
      key="juego-responsable-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/responsible-gaming/"
    />,
    <link
      key="juego-responsable-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/responsible-gaming/"
    />,
    <link
      key="juego-responsable-x-default"
      rel="alternate"
      href="https://global.fun88.com/responsible-gaming/"
      hrefLang="x-default"
    />,
  ],
  'contact-us': [
    <link
      key="contact-us-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://csp.fun88thh.com/?language=th&articleNumber=000009385"
    />,
    <link
      key="contact-us-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://csp.fun88vnu.com/?language=vn&articleNumber=000009355"
    />,
    <link
      key="contact-us-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://csp.fun88zh.com/?language=cn&articleNumber=000009127"
    />,
    <link
      key="contact-us-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/customer-service/#contact"
    />,
    <link
      key="contact-us-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/customer-service/#contact"
    />,
    <link
      key="contact-us-en-IN"
      rel="alternate"
      hrefLang="en-IN"
      href="https://m.fun88ind.com/help/contact-us/"
    />,
    <link
      key="contact-us-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/contact-us"
    />,
    <link
      key="contact-us-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/contact-us"
    />,
    <link
      key="contact-us-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/contact-us"
    />,
    <link
      key="contact-us-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/contact-us"
    />,
    <link
      key="contact-us-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/contact-us"
    />,
    <link
      key="contact-us-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/contact-us/"
    />,
    <link
      key="contact-us-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/contact-us/"
    />,
    <link
      key="contact-us-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/contact-us/"
    />,
    <link
      key="contact-us-x-default"
      rel="alternate"
      href="https://global.fun88.com/contact-us/"
      hrefLang="x-default"
    />,
  ],
  'programa-de-afiliacion': [
    <link
      key="programa-de-afiliacion-th-TH"
      rel="alternate"
      hrefLang="th-TH"
      href="https://www.f952luckyld.com/th-th"
    />,
    <link
      key="programa-de-afiliacion-vi-VN"
      rel="alternate"
      hrefLang="vi-VN"
      href="https://www.f952luckyld.com/vi-vn"
    />,
    <link
      key="programa-de-afiliacion-zh-CN"
      rel="alternate"
      hrefLang="zh-CN"
      href="https://www.f952luckyld.com/zh-cn"
    />,
    <link
      key="programa-de-afiliacion-en-VN"
      rel="alternate"
      hrefLang="en-VN"
      href="https://www.fun88vnplay.com/customer-service/#affiliate"
    />,
    <link
      key="programa-de-afiliacion-en-TH"
      rel="alternate"
      hrefLang="en-TH"
      href="https://www.fun88asiath.com/customer-service/#affiliate"
    />,
    <link
      key="programa-de-afiliacion-es-MX"
      rel="alternate"
      hrefLang="es-MX"
      href="https://www.fun88mx.mx/help/affiliate-program"
    />,
    <link
      key="programa-de-afiliacion-es-CL"
      rel="alternate"
      hrefLang="es-CL"
      href="https://www.fun88.cl/help/affiliate-program"
    />,
    <link
      key="programa-de-afiliacion-es-AR"
      rel="alternate"
      hrefLang="es-AR"
      href="https://www.fun88ar.com/help/programa-de-afiliacion"
    />,
    <link
      key="programa-de-afiliacion-es-PY"
      rel="alternate"
      hrefLang="es-PY"
      href="https://www.fun88py.com/help/programa-de-afiliacion"
    />,
    <link
      key="programa-de-afiliacion-es-EC"
      rel="alternate"
      hrefLang="es-EC"
      href="https://www.fun88.com.ec/help/programa-de-afiliacion"
    />,
    <link
      key="programa-de-afiliacion-en"
      rel="alternate"
      hrefLang="en"
      href="https://global.fun88.com/affiliate/"
    />,
    <link
      key="programa-de-afiliacion-vi"
      rel="alternate"
      hrefLang="vi"
      href="https://vi.fun88.com/affiliate/"
    />,
    <link
      key="programa-de-afiliacion-th"
      rel="alternate"
      hrefLang="th"
      href="https://th.fun88.com/affiliate/"
    />,
    <link
      key="programa-de-afiliacion-x-default"
      rel="alternate"
      href="https://global.fun88.com/affiliate/"
      hrefLang="x-default"
    />,
  ],
}

const HrefLang = ({ page }: { page: keyof typeof HREFLANG }) => {
  const hrefLang = HREFLANG?.[page]
  return hrefLang ? <Helmet>{hrefLang}</Helmet> : null
}

export default HrefLang
